import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { getCombo } from "pages/Admin/User/apis/adminUserApis";

import { useRecoilState } from "recoil";
import { groupListState, comboListState } from "./atom/groupListState";

import {
  TextInput,
  Select,
  Paper,
  PasswordInput,
  FileInput,
  rem,
  MultiSelect,
  Radio,
  Flex,
  Center,
} from "@mantine/core";

import { IconUpload } from "@tabler/icons-react";
import { levelListState } from "./atom/levelListState";

function SRD_Form(props) {
  const { value, fields, onSubmit, submitButton, defaultValues, page } = props;
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues,
  });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [levelList, setLevelList] = useRecoilState(levelListState);
  const [comboList, setComboList] = useRecoilState(comboListState);

  useEffect(() => {
    getCombo().then((res) => {
      setComboList(res);
      setGroupList(
        res
          .filter((item) => item.id === "group")
          .map((item) => ({
            value: item.code,
            label: item.name,
          }))
      );
      setLevelList(
        res
          .filter((item) => item.id === "level")
          .map((item) => ({
            value: item.code,
            label: item.name,
          }))
      );
    });
  }, []);

  const validateID = (value) => {
    const idRegex = /^[a-zA-Z0-9]+$/;
    if (typeof value === "undefined" || !idRegex.test(value)) {
      return "영문자와 숫자만 사용 가능합니다.";
    }
  };

  const validatePassword = (value) => {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/;
    if (!passwordRegex.test(value)) {
      return "알파벳,숫자,특수문자로 이루어진 8자 이상의 패스워드가 필요합니다.";
    }
  };

  const validateConfirmPassword = (value) => {
    const password = getValues("password");
    if (value !== password) {
      return "비밀번호와 일치하지 않습니다";
    }
  };

  const validateInput = (value) => {
    const inputRegex = /.+/;
    if (typeof value === "undefined" || !inputRegex.test(value)) {
      return "이 입력칸을 작성해주세요.";
    }
  };

  const validateSelect = (value) => {
    if (value !== 0 && !value) {
      return "하나를 선택해주세요.";
    }
  };

  const validateFile = (value) => {
    if (!value) {
      return "파일을 업로드해주세요.";
    }
    return undefined;
  };

  return (
    <Paper shadow="xs" p="md" h="90%" w="100%">
      <Center h="100%">
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ height: "100%", position: "relative", width: "55%" }}
        >
          {fields?.map((field, index) => {
            const {
              key,
              name,
              type,
              options,
              component: Component,
              disabled,
              defaultValue,
              hidden, // hidden 속성 추가
              onChange,
              onChangeCustom, // onChangeCustom을 필드 객체에서 추출
            } = field;
            
            if (hidden) return null; // hidden이 true일 경우 렌더링하지 않음

            return (
              <div key={index} style={{ margin: "0.5rem" }}>
                {type === "text" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={options === "validate" && { validate: validateInput }}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                      <>
                        <TextInput
                          label={name}
                          error={errors[key]?.message}
                          disabled={disabled}
                          required={options === "validate"}
                          defaultValue={defaultValue}
                          {...field}
                        />
                      </>
                    )}
                  />
                )}
                {type === "id" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validateID }}
                    render={({ field }) => (
                      <TextInput
                        label={name}
                        error={errors[key]?.message}
                        disabled={disabled}
                        required
                        {...field}
                      />
                    )}
                  />
                )}
                {type === "password" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validatePassword }}
                    render={({ field }) => (
                      <>
                        <PasswordInput
                          label={name}
                          error={errors[key]?.message}
                          required
                          {...field}
                        />
                      </>
                    )}
                  />
                )}
                {type === "confirm_password" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validateConfirmPassword }}
                    render={({ field }) => (
                      <PasswordInput
                        label="비밀번호 확인"
                        error={errors[key]?.message}
                        required
                        {...field}
                      />
                    )}
                  />
                )}

                {type === "file" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validateFile }}
                    render={({ field }) => (
                      <FileInput
                        label={name}
                        placeholder="파일을 업로드 해주세요."
                        error={errors[key]?.message}
                        icon={<IconUpload size={rem(14)} />}
                        required
                        {...field}
                      />
                    )}
                  />
                )}
                {type === "phone_number" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validateInput }}
                    render={({ field }) => (
                      <TextInput 
                      placeholder="[010XXXXYYYY] 형식으로 입력해주세요."
                      label={name} 
                      error={errors[key]?.message} 
                      required {...field} />
                    )}
                  />
                )}
                {page === "object" && type === "select" && (
                  <Controller
                    control={control}
                    name={key}
                    rules={{ validate: validateSelect }}
                    render={({ field: renderField }) => {
                      return (
                        <Select
                          placeholder={`${name}을 골라주세요.`}
                          label={name}
                          error={errors[key]?.message}
                          data={options}
                          required
                          disabled={disabled}
                          value={field.value}
                          // onChange={(value) => field.onChange && field.onChange(value)}
                          onChange={(e) => {
                            renderField.onChange(e);
                            if (onChange) onChange(e);
                          }}
                        />
                      );
                    }}
                  />
                )}
                {page !== "object" && type === "select" && (
                  <Controller
                    control={control}
                    name={key}
                    defaultValue={defaultValue}
                    rules={{ validate: validateSelect }}
                    render={({ field }) => (
                      <>
                        <Select
                          placeholder={`${name}을 골라주세요.`}
                          label={name}
                          error={errors[key]?.message}
                          data={options}
                          required
                          defaultValue={defaultValue}
                          disabled={disabled}
                          {...field}
                          onChange={(e) => {
                            field.onChange(e); // 기존 필드의 onChange 핸들러를 호출
                            if (onChangeCustom) onChangeCustom(e); // 추가된 custom onChange 핸들러
                          }}
                        />
                      </>
                    )}
                  />
                )}
                {type === "multi_select" && (
                  <Controller
                    control={control}
                    name={key}
                    render={({ field }) => (
                      <MultiSelect
                        label={name}
                        error={errors[key]?.message}
                        data={options}
                        required
                        {...field}
                      />
                    )}
                  />
                )}
                {type === "radio_select" && (
                  <Controller
                    control={control}
                    name={key}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                      <Radio.Group
                        label={name}
                        required
                        value={field.value}
                        onChange={(value) => {
                          field.onChange(value);
                          if (onChange) onChange(value);
                        }}
                      >
                        <Flex gap="md">
                          {options &&
                            options.map((option) => (
                              <Radio key={option.value} value={option.value} label={option.label} />
                            ))}
                        </Flex>
                      </Radio.Group>
                    )}
                  />
                )}

                {type === "etc" && (
                  <Controller
                    control={control}
                    name={key}
                    defaultValue={defaultValue}
                    rules={options === "validate" && { validate: validateInput }}
                    render={({ field }) => (
                      <Component
                        name={name}
                        field={field}
                        error={errors[key]?.message}
                        onChange={(event) => field.onChange(event)}
                        defaultValue={defaultValue}
                      />
                    )}
                  />
                )}
              </div>
            );
          })}
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {submitButton}
          </div>
        </form>
      </Center>
    </Paper>
  );
}

export default SRD_Form;
